<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="导出项目差异"
      :visible.sync="dialogVisible"
      width="400">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="excel">导出</el-button>
        <div style="margin-top: 10px;"></div>
        <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" width="120">
              <template slot-scope="scope">
                {{scope.$index+1}}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="项目名称"></el-table-column>
          </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          loading_dade:1,
          dialogVisible:false,
          tableData: [],
          total:0,
          page:12,
          datas:[],
          pid:'',
          date:{
            bill_type:'当前同步',
          },
          loading:false
        }
      },
      mounted(){

      },
      //事件
      methods: {
        //返回数据
        getInvo(datas){
          this.dialogVisible = true;
          //console.log(datas)
          this.selects(1);
        },
        handleSelectionChange(val) {
          this.pid = val.map(req=>{return req.id}).join(",");
        },
        selects(e){
          this.loading_dade = 2;
          this.$myhttp.get('admin/common/pindex',{
            'Content-Type': 'application/json'
          }).then(backdata=>{
            this.loading_dade = 1;
            if(backdata.data.code == 200) {
                this.tableData = backdata.data.data;
            } else {
              this.$message.error(backdata.data.message);
            }

          });
        },
        excel(){
          window.open("http://excel.gdzawy.com:9106/AgingOrder/excel?to=sdasjdkasjj556565&id="+this.pid, '_blank');
        }
    },
  }
</script>

<style scoped>
</style>
sssss



// WEBPACK FOOTER //
// src/components/Admin/Order/Comparison/Moneyexcel.vue